/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_what_we_build_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today the collection covers six areas:`)
};

const es_about_what_we_build_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoy la colección cubre seis áreas:`)
};

const de_about_what_we_build_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute deckt die Sammlung sechs Bereiche ab:`)
};

const nl_about_what_we_build_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vandaag bestrijkt de collectie zes gebieden:`)
};

const fr_about_what_we_build_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aujourd’hui, la collection couvre six domaines :`)
};

const it_about_what_we_build_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oggi la raccolta copre sei aree:`)
};

const pt_br2_about_what_we_build_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoje a coleção cobre seis áreas:`)
};

const pt_about_what_we_build_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualmente, a coleção abrange seis áreas:`)
};

const ja_about_what_we_build_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在、このコレクションは6つの分野をカバーしています:`)
};

const zh_about_what_we_build_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前，该工具集涵盖六大领域：`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_what_we_build_p2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_what_we_build_p2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_what_we_build_p2", locale)
	if (locale === "en") return en_about_what_we_build_p2(inputs)
	if (locale === "es") return es_about_what_we_build_p2(inputs)
	if (locale === "de") return de_about_what_we_build_p2(inputs)
	if (locale === "nl") return nl_about_what_we_build_p2(inputs)
	if (locale === "fr") return fr_about_what_we_build_p2(inputs)
	if (locale === "it") return it_about_what_we_build_p2(inputs)
	if (locale === "pt-BR") return pt_br2_about_what_we_build_p2(inputs)
	if (locale === "pt") return pt_about_what_we_build_p2(inputs)
	if (locale === "ja") return ja_about_what_we_build_p2(inputs)
	return zh_about_what_we_build_p2(inputs)
};